"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDrawerTab = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Tabs = __importStar(require("@radix-ui/react-tabs"));
var react_1 = require("@stitches/react");
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var StyledTab = (0, react_1.styled)(Tabs.Trigger, {
    backgroundColor: stitches_config_1.theme.colors.gray3,
    color: stitches_config_1.theme.colors.gray11,
    padding: "12px",
    border: "1px solid ".concat(stitches_config_1.theme.colors.gray6),
    borderBottom: "none",
    borderRadius: "6px 6px 0px 0px",
    "&:hover": {
        color: stitches_config_1.theme.colors.gray12,
    },
    '&[data-state="active"]': {
        backgroundColor: stitches_config_1.theme.colors.white,
        color: stitches_config_1.theme.colors.gray12,
        borderBottom: "1px solid ".concat(stitches_config_1.theme.colors.white),
    },
});
function FileDrawerTab(props) {
    return ((0, jsx_runtime_1.jsx)(StyledTab, __assign({ value: props.value }, { children: (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm-plus" }, { children: props.text })) })));
}
exports.FileDrawerTab = FileDrawerTab;
//# sourceMappingURL=FileDrawerTab.js.map